import React, { useRef, useState } from 'react'

const MDB4FileInput = ({
  btnTitle = 'Choose file',
  textFieldTitle = 'Upload your file',
  btnColor = 'primary',
  className = '',
  textFieldClassName = '',
  btnClassName = '',
  multiple = false,
  disabled = false,
  accept,
  name,
  id,
  value,
  reset = false,
  getValue,
  onChange,
}) => {
  const [fileName, setFileName] = useState(false)
  const inputRef = useRef(null)

  const handleChange = evt => {
    const files = evt.target.files
    if (files && files.length > 0) {
      if (files.length > 1) {
        const names = []
        for (let i = 0; i < files.length; i++) names.push(files[i].name)
        setFileName(names.join(', '))
      } else setFileName(files[0].name)
    } else setFileName(false)
    ;(typeof getValue === 'function' ? getValue : () => {})(files)
    ;(typeof onChange === 'function' ? onChange : () => {})(evt)
  }

  const handleReset = () => {
    if (inputRef.current) inputRef.current.value = ''
    setFileName(false)
    ;(typeof getValue === 'function' ? getValue : () => {})(null)
    ;(typeof onChange === 'function' ? onChange : () => {})({ target: { name, files: null, value: '' } })
  }

  const btnClasses = ['btn', `btn-${btnColor}`, 'btn-sm', 'float-left', btnClassName].filter(Boolean).join(' ')

  return (
    <div className={['file-field', 'md-form', className].filter(Boolean).join(' ')}>
      <div className={btnClasses}>
        <span>{btnTitle}</span>
        <input
          ref={inputRef}
          type='file'
          name={name}
          id={id}
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          onChange={handleChange}
        />
      </div>
      <div className='file-path-wrapper'>
        <input
          className={['file-path', 'validate', textFieldClassName].filter(Boolean).join(' ')}
          type='text'
          readOnly
          disabled={disabled}
          placeholder={fileName || value || textFieldTitle}
        />
      </div>
      {reset && (
        <button
          type='button'
          className='close'
          style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }}
          onClick={handleReset}
        >
          <span aria-hidden='true'>&times;</span>
        </button>
      )}
    </div>
  )
}

export default MDB4FileInput
